import { get } from 'lodash';
import * as React from 'react';
import { useEffect } from 'react';
import { gamification } from '../../api/event';
import { nonPiletInstances, PILET_NAMES } from '../../configs/config';
import { PATHS, STORAGE_KEYS } from '../../Utils/constants';
import { getItem } from '../../Utils/Storage';
import { parseQueryParams } from '../../Utils/utils';
import { getRealmOwnerData } from '../TraderUI/trader.utils';
import { Loading } from '../UI/loading';

const Customers = () => {
  const [d, setD] = React.useState({
    isLoading: true
  });

  const hideLoading = () => {
    setD({
      ...d,
      isLoading: false
    });
  };

  const frame: any = document.getElementsByTagName('iframe');
  const params = parseQueryParams(get(window, 'location.search', {}));
  const onbehalfofloan = get(params, 'onbehalfofloan', 'false');
  const [myCustomers]: any = nonPiletInstances.filter(
    ({ appName }) => appName === PILET_NAMES.ON_BEHALF_LOAN
  );

  useEffect(() => {
    gamification({
      type: 'OPEN_APP',
      event: `OPEN_${PILET_NAMES.ON_BEHALF_LOAN}`
    });
    window.addEventListener('message', (event) => {
      const action = get(event, 'data.action', '');
      if (action === 'get_freeWheel_details') {
        setTimeout(() => {
          const [customersframe] = frame;
          if (customersframe.contentWindow) {
            const authData = getItem(STORAGE_KEYS.AUTH_CONFIG);
            const realmId = getRealmOwnerData(authData).realmOwnerData;
            customersframe.contentWindow.postMessage(
              {
                call: 'send_freeWheel_details',
                value: {
                  ...authData,
                  realmId: realmId.realmIdentifier,
                  userName: realmId.realName,
                  facilityId: 3831,
                  role:
                    onbehalfofloan == 'true' ||
                    location.pathname === PATHS.ONBEHALF_OF
                      ? 'on_behalf_of_loan'
                      : null,
                  customDomain: process.env.CUSTOM_DOMAIN
                }
              },
              '*'
            );
          }
        }, 3000);
      } else if (action === 'open_loan') {
      
        const frame: any = document.getElementById('customersframe');
        frame.remove()
        const { realmId, userId, name } = event.data.value;
        localStorage.setItem('FINTECH_USER_ID', userId)
        history.pushState(
          '',
          '',
          `loans?userId=${userId}&realmId=${realmId}&name=${name}`
        );
        // history.pushState('', '', `loans?userId=${userId}&realmId=${realmId}`);
        var popStateEvent = new PopStateEvent('popstate', {});
        dispatchEvent(popStateEvent);
        gamification({ type: 'CLOSE_APP', event: 'CLOSE_FREEWHEEL' });

        gamification({
          type: 'OPEN_APP',
          event: `OPEN_${PILET_NAMES.FINTECH}`
        });
      } else if (action === 'close_freeWheel') {
        history.pushState('', '', '/');
        var popStateEvent = new PopStateEvent('popstate', {});
        dispatchEvent(popStateEvent);
        gamification({
          type: 'CLOSE_APP',
          event: `CLOSE_${PILET_NAMES.ON_BEHALF_LOAN}`
        });
      }
    });
  }, []);
  return (
    <div className='w-screen h-screen'>
      {d.isLoading && <Loading />}
      <iframe
        id='customersframe'
        className='w-full h-full'
        onLoad={hideLoading}
        src={myCustomers.url}
      ></iframe>
    </div>
  );
};

export default Customers;
